/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TruckInfoVo } from './TruckInfoVo';
import {
    TruckInfoVoFromJSON,
    TruckInfoVoFromJSONTyped,
    TruckInfoVoToJSON,
    TruckInfoVoToJSONTyped,
} from './TruckInfoVo';

/**
 * 
 * @export
 * @interface ResponseTruckInfoVo
 */
export interface ResponseTruckInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseTruckInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseTruckInfoVo
     */
    message?: string;
    /**
     * 
     * @type {TruckInfoVo}
     * @memberof ResponseTruckInfoVo
     */
    data?: TruckInfoVo;
}

/**
 * Check if a given object implements the ResponseTruckInfoVo interface.
 */
export function instanceOfResponseTruckInfoVo(value: object): value is ResponseTruckInfoVo {
    return true;
}

export function ResponseTruckInfoVoFromJSON(json: any): ResponseTruckInfoVo {
    return ResponseTruckInfoVoFromJSONTyped(json, false);
}

export function ResponseTruckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseTruckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : TruckInfoVoFromJSON(json['data']),
    };
}

export function ResponseTruckInfoVoToJSON(json: any): ResponseTruckInfoVo {
    return ResponseTruckInfoVoToJSONTyped(json, false);
}

export function ResponseTruckInfoVoToJSONTyped(value?: ResponseTruckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': TruckInfoVoToJSON(value['data']),
    };
}

